import React, { useContext } from "react";
import { IconAtom2 } from "../atoms/iconAtom";
import { UserContext } from "../App";

export function EmptyComp({ userName, userID, currentUserID, navigationContext }) {
  const isUserLoggedIn = userID !== undefined;
  const isCurrentUser = userID === currentUserID;
  const userInformation = useContext(UserContext)
  const isPublic = userInformation.account_type === 1

  const { title, description, cursorStyle, iconName  } = isUserLoggedIn
  ? isCurrentUser
  ? {
      title: `Je heb nog geen cursussen`,
      description: "Helaas zijn er geen cursussen beschikbaar.",
      cursorStyle: "pointer",
      iconName: "book-off",
    }
  : {
      title: `${userName} heeft nog geen cursussen`,
      description: "Ga naar cursus om een cursus aan te maken of starten",
      cursorStyle: "default",
      iconName: "book-off", 
    }
: {
    title: `${isPublic ? "Lead": "Gebruiker"} niet gevonden`,
    description: "We kunnen je gegevens niet vinden.",
    cursorStyle: "default",
    iconName: "user-cancel",
  };

  const handleClick = () => {
    if (!isUserLoggedIn) {
      navigationContext.handleNavigation({
        courseID: 0,
        navigation: 2,
        enrollment: 0,
      });
    }
  };

  return (
    <div
      className="empty-comp"
      onClick={handleClick}
      style={{ cursor: cursorStyle }}
    >
      <div className="empty-card">
        <div className="empty-icon">
          <IconAtom2
            style={{
              height: "60px",
              width: "60px",
              boxSizing: "border-box",
              color: "var(--error-500)",
              backgroundColor: "var(--error-100)",
            }}
            iconSize={40}
            icon2={iconName}
          />
        </div>
        <div className="empty-content">
          <p className="standard-text course-title bold-text grey-900">{title}</p>
          <p className="small-text progress-description grey-600">{description}</p>
        </div>
      </div>
    </div>
  );
}
